import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatDistanceToNow } from 'date-fns';

export const GroupActivityMonitor: React.FC = () => {
  const { data: groupStates } = useQuery({
    queryKey: ['strategy-group-states'],
    queryFn: async () => {
      // @ts-ignore - strategy_group_states table will be created by migration
      const { data } = await supabase
        // @ts-ignore
        .from('strategy_group_states')
        .select(`
          *,
          strategy_groups(name, group_type, is_active),
          bots(name)
        `);
      return data as any[];
    },
    refetchInterval: 3000,
  });

  if (!groupStates || groupStates.length === 0) {
    return null;
  }

  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle>Group Activity</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {groupStates.map((state: any) => (
          <div
            key={state.group_id}
            className="flex items-center justify-between p-3 border rounded-lg"
          >
            <div>
              <p className="font-medium">{state.strategy_groups.name}</p>
              <Badge variant="outline" className="mt-1">
                {state.strategy_groups.group_type}
              </Badge>
            </div>
            <div className="text-right">
              {state.active_bot_id ? (
                <>
                  <Badge variant="default" className="mb-1">
                    Active: {state.bots.name}
                  </Badge>
                  <p className="text-xs text-muted-foreground">
                    Since {formatDistanceToNow(new Date(state.active_since), { addSuffix: true })}
                  </p>
                </>
              ) : (
                <Badge variant="secondary">Idle</Badge>
              )}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
